<template>
    <div>
        <FileUpload mode="basic" name="demo[]"  chooseLabel="ייבוא" uploadLabel="שמור"  @before-send="beforeUpload" :multiple="true" accept=".csv"
                    :maxFileSize="1000000">
        </FileUpload>
    </div>
</template>

<script>
export default {
    name: "uploadData",
    methods: {
        beforeUpload(event) {
            alert("123")
            console.log("event",event.formData)
        }
    },
}
</script>

<style scoped>

</style>